import {
  ReportPeriodSchema,
  type ReportPeriod as GeneratedReportPeriod
} from '~/services/api/generated'

// Mirrors backend App\Enums\ReportPeriod

export type ReportPeriod = GeneratedReportPeriod

export const ReportPeriod = {
  SEVEN_DAYS: ReportPeriodSchema.enum['7days'],
  THIRTY_DAYS: ReportPeriodSchema.enum['30days'],
  ALL: ReportPeriodSchema.enum.all,
  ALL_TIME: ReportPeriodSchema.enum['all-time']
} satisfies Record<string, GeneratedReportPeriod>

export const ReportPeriodValues: readonly GeneratedReportPeriod[] = [
  ReportPeriodSchema.enum['7days'],
  ReportPeriodSchema.enum['30days'],
  ReportPeriodSchema.enum.all,
  ReportPeriodSchema.enum['all-time']
]
